<template>
  <section>
    <div class="transparent-block">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-row-class-name="'tableHeader'"
        @row-click="rowClick"
      >
        <el-table-column
          label="All Agents">
          <template #default="{ row }">
            <div class="flex">
              <font-awesome-icon
                icon="headset"
                class="pointer"
              />
              <div class="margin-left">
                <span class="action-title">{{ row.created_date }}</span><br>
                <span class="little-span">{{ row.created_date }}</span><br>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>

    </div>
    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange"/>
  </section>
</template>

<script>
import {getNesLetterList} from '@/api/newsletter'
export default {
  name: '',
  data () {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      search: '',
      tableData: []
    }
  },
  mounted(){
    this.network().getNesLetterList()
  },
  methods: {
    handleClick(){

    },
    rowClick() {
      this.$router.push({
        path: '/administration/account/audit/detail',
      })
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getNesLetterList()
    },
    network() {
      return {
        getNesLetterList: async () => {
          const { data } = await getNesLetterList({
            search: this.search,
            page: this.pageConfig.currentPage
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        }
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.transparent-block{
  border: 1px solid #E1E4E8;
  //border-bottom: 0;
  border-radius: 5px;
}
::v-deep .tableHeader{
    height: 20px;
    width: 80px;
    color: #24292E;
    font-family: Inter;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 20px;
  th{
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    /* Text/text-gray-dark */
    color: #24292E!important;
  }

}
::v-deep .el-table{
  border-radius: 5px;
}
.flex{
    padding: 15px 16px;
  align-items: baseline;
  .margin-left{
    margin-left: 8px;
  }
}
.action-title{
    color: #24292E;
    font-family: Inter;
    font-size: 16px;
    font-weight: 600;
}
.little-span{
  color: #6A737D;
  font-family: Inter;
  font-size: 12px;
}
</style>
